import { AvForm } from "availity-reactstrap-validation"
import { CustomDatePicker, CustomSelect, CustomSelectAsync } from "components/Common"
import CustomSearchBar from "components/Common/CustomTable/SearchBar"
import { parameterCode } from "constant"
import { getCodesByParameterId } from "helpers/app-backend"
import { convertDateFormat, getI18nextLng } from "helpers/utilities"
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
const HeaderButtons = forwardRef(
    ({
        t,
        onSubmit,
    }, ref) => {
        let lang = getI18nextLng()
        const [searchText, setSearchText] = useState('')
        const [serviceTypes, setServiceTypes] = useState([])
        const [serviceType, setServiceType] = useState('')
        const [dates, setDates] = useState({
            dateTo: convertDateFormat(new Date(), "YYYY-MM-DD"),
            dateFrom: convertDateFormat(new Date(), "YYYY-MM-DD"),
            type: 'A',
            search: ''
          })
        useEffect(() => {
            getServiceType()
        }, [])
        useImperativeHandle(ref, () => ({
            GetDataFilter: () => {
                return getData()
            },
        }));
        const getServiceType = async () => {
            const query = { lang }
            let res = await getCodesByParameterId(parameterCode.SERVICE_TYPE, query);
            res?.map(_item => {
                _item.value = _item.code
                _item.label = `${_item.message}`
                return _item
            });
            res = res || []
            // res.unshift({
            //     value: '',
            //     label: t("ServiceType")
            // })
            setServiceTypes(res)
        }
        const getData = (isClear = false) => {
            return {
                start: dates.dateFrom,
                end: dates.dateTo,
                partnerCode: serviceType,
                search: isClear ? '' : searchText
            }
        }

        useEffect(() => {
            onSubmit && onSubmit(getData())
        }, [serviceType, dates])

        const requestDateOnChange = (date) => {
            dates.dateFrom = convertDateFormat(date.time[0], "YYYY-MM-DD")
            dates.dateTo = convertDateFormat(date.time[1], "YYYY-MM-DD")
            setDates({ ...dates });
          }
        const sidDate = useMemo(() => [convertDateFormat(dates.dateFrom, 'DD-MM-YYYY'), convertDateFormat(dates.dateTo, 'DD-MM-YYYY')], [dates.dateFrom, dates.dateTo])
        const minDate = new Date().setMonth(new Date().getMonth() - 3)
        
        return (
            <React.Fragment>
                <AvForm>
                    <div className="right-pane-result-detail row" style={{ paddingTop: '10px' }}>
                        <div className="col-12 mb-2">
                            <CustomSearchBar
                                onSearch={(e) => {
                                    setSearchText(e.target.value)
                                }}
                                searchText={searchText}
                                placeholder={t("testResultPage:Search Test Send")}
                                onClear={() => {
                                    setSearchText('')
                                    onSubmit && onSubmit(getData(true))
                                    setDates({ ...dates })
                                }}
                                onSubmit={(e) => {
                                    e.preventDefault()
                                    onSubmit && onSubmit(getData())
                                }}
                            />
                        </div>
                        <div className="col-12 d-flex">
                            <div className="mb-2 flex-1" style={{ marginRight: '2px' }}>
                                {/* <CustomDatePicker
                                    name="requestDate"
                                    label={''}
                                    format={"d-m-Y"}
                                    dateFormat="d-m-Y"
                                    value={dates}
                                    onChangeHandler={requestDateOnChange}
                                    closeOnSelect={true}
                                    mode='range'
                                    // maxDate={new Date(new Date().setHours(0, 0, 0, 0))}
                                    maxDate={new Date()}
                                    minDate={minDate}
                                    conjunction={'  '}
                                /> */}
                                <CustomDatePicker
                                    style={{ width: '100%' }}
                                    name="requestDate"
                                    placeholder={t("Request Date")}
                                    format={"d-m-Y"}
                                    dateFormat="d-m-Y"
                                    value={sidDate}
                                    onChangeHandler={requestDateOnChange}
                                    showIcon
                                    mode='range'
                                    maxDate={new Date()}
                                    minDate={minDate}
                                    closeOnSelect
                                    />
                            </div>
                            <div className="mb-2 flex-1" style={{ marginLeft: '2px' }}>
                                <CustomSelectAsync
                                    name="partnerCode"
                                    value={serviceType}
                                    valueName={""}
                                    code={parameterCode.PARTNER_ORGANIZATION}
                                    label={""}
                                    placeholder={t("resultPage:Partner Send")}
                                    onChange={(e, vals, a, values) => {
                                        // setModel({ ...model, groupCode: vals[0] })
                                        // onChangeGroup(values[0])
                                        setServiceType(vals[0] || '')
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </AvForm>
            </React.Fragment>
        )
    })

const mapStateToProps = ({ }) => ({
})

const mapDispatchToProps = dispatch => ({
})
HeaderButtons.displayName = 'HeaderButtons';
export default withTranslation(["testResultPage,common", "resultPage"], { withRef: true })(connect(
    mapStateToProps,
    mapDispatchToProps, null, { forwardRef: true }
)(HeaderButtons))